import { createFileRoute } from "@tanstack/react-router";

import OfferRetomarPageSafe from "@/components/OfferRetomarPageSafe";

export const Route = createFileRoute("/oferta-retomar")({
  component: OfferRetomarPageSafe,
  head: () => ({
    meta: [
      { title: "O Código de Inanna — A Jornada das Sete Portas do Amor" },
      {
        name: "description",
        content:
          "Atravesse as Sete Portas do Amor em uma jornada guiada de 7 dias para recuperar sua paz, sua voz e seu poder.",
      },
      {
        property: "og:title",
        content: "O Código de Inanna — A Jornada das Sete Portas do Amor",
      },
      {
        property: "og:description",
        content:
          "Uma experiência digital inspirada em Inanna, com uma porta, um Código Quântico e uma prática por dia.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://codigodeinanna.dimmedia.net/oferta" }],
  }),
});
